/**
 * 画像情報更新用VO
 */
export class UpdateImageInfoModel {
  public ImageGroupNO: string = <string>'';				// 画像グループNO
  public StartOrderCode: string = <string>'';				// 使用開始受注コード
  public EndOrderCode: string = <string>'';				// 使用終了受注コード
  public EFriendsProduct: boolean = <boolean>false;			// eフレンズ商品
  public ImageBelongID: string = <string>'';				// 画像所属
  public PCode: string = <string>'';						// Ｐコード
  public PhotoSchedule: string = <string>'';				// 撮影予定日
  public PhotoStudioID: string = <string>'';				// 撮影場所ＩＤ
  public SampleOrderingCode: string = <string>'';			// サンプル発注先コード
  public BillingCode: string = <string>'';					// 請求先コード
  public BillingTargetDiv: boolean = <boolean>false;		// 請求対象区分
  public Memo: string = <string>'';						// メモ
  public ImageKind: string = <string>'';					// 画像種類

  public ImageInfoInsertList: Array<any> = [];		// 追加対象の画像情報の属性名
  public ImageInfoUpdateList: Array<any> = [];		// 更新対象の画像情報の属性名
  public ImageInfoDeleteList: Array<any> = [];		// 削除対象の画像情報の属性名
  public ReferenceImageDeleteList: Array<any> = []; // 削除対象の参考資料情報の属性名
}
